module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-BOOSTER-GREEN-2.35b5ba82.jpg";